/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Table, TableCell, TableHead, TableRow, TextField } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { useEffect, useState, useMemo } from 'react';
import ListItemProduct from './element/ProductListElement/ListItemProduct';
import {
    addNewLineProduct,
    getListProductData,
    isDisabledButtonCancel,
    isDisabledButtonSubmit,
    onSubmitData,
    onCancelResetData,
    onClickYesCancel
} from './handler/ProductListHandler';
import './styles/ProductList.css';
import { ProductListStyle } from './styles/ProductListStyle';
import LoadingPanel from '../common/LoadingPanel';
import { userAtom } from '@/state/atom/userAtom';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { useSnackbar } from 'notistack';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import { panelInitDataAtom } from '@/state/atom/panelAtom';
import { updatePanelInitData } from '../multiPanel/panel/handler/PanelHandler';
import { productManagementAtom } from '@/state/atom/productManagementAtom';
import { closePanelTabSelector } from '@/state/selector/panelSelector';
import Constant from '@/common/constant/Constant';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import I18n from '@/rI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function ProductList({ API, onOpenEditionList, panelId, tabId }) {
    // Re-render when the translation dictionary loads/updates.
    useTranslationSubscription();

    const [hasError, setHasError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [listDataProduct, setListDataProduct] = useState([]);
    const [listDataDefault, setListDataDefault] = useState([]);
    const [listDeleteProduct,setListDeleteProduct] = useState([]);
    const [listEditStatusProduct,setListEditStatusProduct] = useState([]);
    const [triggerReload, setTriggerReload] = useState('');
    const [isEdit, setIsEdit] = useState(false);
    const userDetail = useRecoilValue(userAtom);
    const [isShowPopUpCancel, setIsShowPopUpCancel] = useState(false);
    const [panelInitData, setPanelInitData] = useRecoilState(panelInitDataAtom);
    const [isClosePanelProduct, setIsClosePanelProduct] = useRecoilState(productManagementAtom);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const { enqueueSnackbar } = useSnackbar();
    const [isShowPopUpReload,setIsShowPopUpReload] = useState(false)
    const [increaseRate, setIncreaseRate] = useState(0);
    const [increaseRateInput, setIncreaseRateInput] = useState(0);
    const [increaseRateInputError, setIncreaseRateInputError] = useState();

    const classes = ProductListStyle();

    const isEditIncreaseRate = useMemo(() => {
        if (increaseRateInput !== increaseRate) {
            return true;
        }
    }, [increaseRateInput, increaseRate]);

    const renderGroupButtonSubmit = () => {
        return (
            <div className="prdlist-header-wrapper">
                <div className="pl-16px pr-16px prdlist-header-container">
                    <div className="title-prd-list">{trI18n('TITLE-PRODUCT-LIST')}</div>
                    <div>
                        {/* btn cancel  */}
                        <Button
                            className="btn-send btn-light btn-hg32"
                            variant="contained"
                            color="primary"
                            disabled={isDisabledButtonCancel(
                                isEdit,
                                listDataProduct,
                                listDataDefault,
                                listDeleteProduct,
                                listEditStatusProduct,
                                isEditIncreaseRate,
                                increaseRateInputError
                            )}
                            onClick={() => setIsShowPopUpCancel(true)}
                        >
                            {trI18n('COMBTN001')}
                        </Button>

                        {/* btn submit  */}
                        <Button
                            className="btn-send btn-primary btn-hg32"
                            variant="contained"
                            color="primary"
                            data-cy="btn-submit-add-ticket"
                            disabled={isDisabledButtonSubmit(
                                hasError,
                                listDataProduct,
                                isEdit,
                                listDataDefault,
                                listDeleteProduct,
                                listEditStatusProduct,
                                isEditIncreaseRate,
                                increaseRateInputError
                            )}
                            onClick={async () =>
                                await onSubmitData(
                                    API,
                                    listDataProduct,
                                    setListDataProduct,
                                    setIsLoading,
                                    setTriggerReload,
                                    userDetail.id,
                                    setIsEdit,
                                    enqueueSnackbar,
                                    setHasError,
                                    listDeleteProduct,
                                    listEditStatusProduct,
                                    setIsShowPopUpReload,
                                    setListDeleteProduct,
                                    setListEditStatusProduct,
                                    increaseRateInput,
                                )
                            }
                        >
                            {trI18n('COMBTN011')}
                        </Button>
                    </div>
                </div>
            </div>
        );
    };

    useEffect(() => {
        (async () => {
            await getListProductData(API, setListDataProduct, setIsLoading, setListDataDefault, setIncreaseRateInput, setIncreaseRate);
        })();

        return () => {
            setListDataProduct([])
            setIsLoading(false)
            setListDataDefault([])
        }
    }, [triggerReload]);

    useEffect(() => {
        updatePanelInitData(panelId, tabId, panelInitData, setPanelInitData, 'isEditedData', isEdit);
    }, [isEdit]);

    const onChangeIncreaseRate = e => {
        const value = e.target.value.trim();
        const regex = /^\d+$/;
        const isValid = regex.test(value);
        setIncreaseRateInput(value);
        if (!value) {
            setIncreaseRateInput(0);
            setIncreaseRateInputError('');
            return;
        }
        if (!isValid) {
            setIncreaseRateInputError(I18n.get('MSG-CM-WRONG-NUMBER-FORMAT').replace('{{min_value}}', '0'));
            return;
        }
        if (value.length > 3) {
            setIncreaseRateInputError(I18n.get('MSG-CM-OVER-MAXLENGTH').replace('{{maxLength}}', '3'));
            return;
        }
        setIsEdit(true);
        setIncreaseRateInput(Number(value));
        setIncreaseRateInputError('');
    };


    return (
        <div className="prod-list">
            <LoadingPanel isLoading={isLoading} />
            {/* button cancel and submit  */}
            {renderGroupButtonSubmit()}

            {/* button add new line  */}
            <div className='add-new-wrap'>
                <div className='prd-btn-add-newline pl-16px pr-16px'>
                    <Button
                        variant="text"
                        startIcon={<AddIcon />}
                        className={classes.buttonAddNewLine}
                        onClick={() => addNewLineProduct(listDataProduct, setListDataProduct, setIsEdit)}
                    >
                        {trI18n('BUTTON-ADD-PRODUCT')}
                    </Button>

                    <div className='increase-rate'>
                        <span>{trI18n('LABEL-INCREASE-RATE')}</span>
                        <TextField
                            variant='outlined'
                            className="form-control-input form-control-wrapInput form-control-hg32 increase-input"
                            placeholder=""
                            onChange={onChangeIncreaseRate}
                            value={increaseRateInput}
                            error={!!increaseRateInputError}
                        />
                        <span>%</span>
                    </div>
                </div>
                <div className='increase-rate-danger'>{tr(increaseRateInputError)}</div>
            </div>

            {/* table  */}
            <div className="scroll-table">
                <Table className={classes.tableList}>
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.tableCellProductName}>
                                {trI18n('TABLE-COLUMN-PRODUCT-NAME')}
                            </TableCell>
                            <TableCell className={classes.tableCellStatusName}>
                                {trI18n('TABLE-COLUMN-SALES-STATUS')}
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <ListItemProduct
                        listDataProduct={listDataProduct}
                        onOpenEditionList={onOpenEditionList}
                        setListDataProduct={setListDataProduct}
                        setHasError={setHasError}
                        setIsEdit={setIsEdit}
                        setList
                        setListDeleteProduct={setListDeleteProduct}
                        setListEditStatusProduct = {setListEditStatusProduct}
                        listDeleteProduct ={listDeleteProduct}
                        listEditStatusProduct = {listEditStatusProduct}
                    />
                </Table>
            </div>

            {/* dialog cancel  */}
            <ConfirmDialog
                isOpen={isShowPopUpCancel}
                msgConfirm={trI18n('MSG-CM-CONFIRM-EXIT-PAGE-WITHOUT-SAVING')}
                okCallBack={async () =>
                    await onClickYesCancel(
                        API,
                        listDataProduct,
                        setListDataProduct,
                        setIsLoading,
                        setTriggerReload,
                        userDetail.id,
                        setIsEdit,
                        enqueueSnackbar,
                        setHasError,
                        setIsShowPopUpCancel,
                        hasError,
                        isEdit,
                        setIsClosePanelProduct,
                        listDeleteProduct,
                        listEditStatusProduct,
                        setIsShowPopUpReload,
                        setListDeleteProduct,
                        setListEditStatusProduct,
                        increaseRateInput,
                        isEditIncreaseRate,
                        increaseRateInputError
                    )
                }
                closeCallBack={() =>
                    onCancelResetData(
                        setIsShowPopUpCancel,
                        setIsEdit,
                        setHasError,
                        setListDataProduct,
                        [...listDataDefault],
                        setListDeleteProduct,
                        setListEditStatusProduct,
                        increaseRate,
                        setIncreaseRateInput,
                        setIncreaseRateInputError
                    )
                }
                cancelCallBack={() => {
                    setIsShowPopUpCancel(false);
                }}
                textSubmit={trI18n('COMBTN002')}
                textClose={trI18n('COMBTN007')}
                isShowClassnameButton={false}
            />

            {/* dialog close panel  */}
            <ConfirmDialog
                isOpen={isClosePanelProduct.isClose}
                msgConfirm={trI18n('MSG-CM-CONFIRM-EXIT-PAGE-WITHOUT-SAVING')}
                okCallBack={async () =>{
                    const clickYesCancelRes = await onClickYesCancel(
                        API,
                        listDataProduct,
                        setListDataProduct,
                        setIsLoading,
                        setTriggerReload,
                        userDetail.id,
                        setIsEdit,
                        enqueueSnackbar,
                        setHasError,
                        setIsShowPopUpCancel,
                        hasError,
                        isEdit,
                        setIsClosePanelProduct,
                        listDeleteProduct,
                        listEditStatusProduct,
                        setIsShowPopUpReload,
                        setListDeleteProduct,
                        setListEditStatusProduct,
                        increaseRateInput,
                        isEditIncreaseRate,
                        increaseRateInputError
                    )
                    if (clickYesCancelRes) {
                        closePanelTab({
                            event: null,
                            panelType: Constant.PANEL_TYPE.PRODUCT_MANAGEMENT,
                            panelId: panelId,
                            tabId: tabId
                        })
                    }
                }
                }
                closeCallBack={() => {
                    closePanelTab({
                        event: null,
                        panelType: Constant.PANEL_TYPE.PRODUCT_MANAGEMENT,
                        panelId: panelId,
                        tabId: tabId
                    })
                    setIsClosePanelProduct({isClose: false})
                }
                    
                }
                cancelCallBack={() => {
                    setIsClosePanelProduct({isClose: false});
                }}
                textSubmit={trI18n('COMBTN002')}
                textClose={trI18n('COMBTN007')}
                isShowClassnameButton={false}
            />
             <ConfirmDialog 
                isOpen={isShowPopUpReload}
                msgConfirm={trI18n('COMMSG030')}
                okCallBack={() => window.location.reload()}
            />
        </div>
    );
}
